import { useContext } from "react";
import toastContext from "src/utils/config/toast-configuration.js";
/**
 * 
 * @returns function({
            title=String,
            subtitle= String,
            icon=ReactComponent,
            body=String
        })
 */
export default function useToast(){
    return useContext(toastContext)
}